import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { Select } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { RegistrationErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/ErrorContext';
import { modal } from 'src/utils/Modal';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const CustomerDatabase = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { dbEmptyError, setDbEmptyError } = React.useContext(
    RegistrationErrorContext,
  );
  const { data, onChange, list = [], setHasModified, disableEdit } = props;
  const uuid = get(data, 'uuid');
  const handleOnDbChange = (dUuid) => {
    const _m = () => {
      setHasModified(true);
      setDbEmptyError(false);
      if (dUuid) {
        const db = list.find((i) => i.uuid === dUuid);
        if (onChange) {
          onChange(db);
        }
      } else {
        if (onChange) {
          onChange(null);
        }
      }
    };

    if (uuid) {
      modal.error({
        title: getI18n('salesChannelRegistration.index.changeCustomerDatabase'),
        content: getI18n(
          'salesChannelRegistration.index.changeCustomerDatabaseContent',
        ),
        onCancel: () => {
          return;
        },
        onCancelText: getI18n('general.cancel'),
        onOk: _m,
        okText: getI18n('salesChannelRegistration.index.change'),
      });
    } else {
      _m();
    }
  };
  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.customerDatabase')}>
      <div className={css.tip}>
        {getI18n('salesChannelRegistration.index.customerDatabaseTip')}
      </div>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'salesChannelRegistration.index.customerDatabase',
                )}
                id={'salesChannelRegistrationDbSelection'}>
                <Select
                  disabled={disableEdit}
                  error={dbEmptyError}
                  value={uuid}
                  help={getI18n(
                    'salesChannelRegistration.index.customerDatabasehelp',
                  )}
                  placeholder={getI18n(
                    'salesChannelRegistration.index.customerDatabaseplaceholder',
                  )}
                  onChange={handleOnDbChange}
                  size='large'
                  optionsList={(list || []).map((i) => {
                    const uuid = get(i, 'uuid');
                    const name = get(i, 'name');
                    return { value: uuid, label: name };
                  })}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionWrapper>
  );
};
export default CustomerDatabase;
